var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.size,style:(`background-image: url('${_vm.imageUrl}');`),attrs:{"id":"avatar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }